// extracted by mini-css-extract-plugin
module.exports = {"warning":"NotFound_warning__3KVOw"};